function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionBonusProgramOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.474 17.743l4.475-4.35-.001-.001a.884.884 0 00.038-.04c.452-.494.156-1.292-.53-1.382l-6.081-.799-2.606-5.582c-.305-.657-1.263-.655-1.567.003l-2.581 5.59-6.08.822c-.705.095-.993.936-.488 1.424l4.494 4.334-1.113 6.155c-.125.7.644 1.226 1.277.872l5.307-2.973 5.319 2.954c.635.352 1.402-.176 1.273-.877l-1.136-6.15zM20.2 21.85l-.886-4.797 3.511-3.412-4.798-.63-2.034-4.36-2.016 4.366-4.795.648 3.524 3.399-.868 4.8 4.177-2.339 4.185 2.325z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28.5c6.904 0 12.5-5.596 12.5-12.5S22.904 3.5 16 3.5 3.5 9.096 3.5 16 9.096 28.5 16 28.5zm0 2c8.008 0 14.5-6.492 14.5-14.5S24.008 1.5 16 1.5 1.5 7.992 1.5 16 7.992 30.5 16 30.5z",
    fill: props.color
  }));
}

export default SvgIconPromotionBonusProgramOutline;